var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 841.89 595.28",
    style: {
      enableBackground: "new 0 0 841.89 595.28"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "4.44,251.63 4.44,341.09 10.15,341.09 10.15,269.6 49.93,325.89 89.7,269.6 89.7,341.09 95.41,341.09  95.41,251.63 49.93,315.99  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M208.07,252.98c-8.31,0-15.51,4.8-19.02,11.76c-7.89-7.28-18.4-11.76-29.96-11.76 c-24.42,0-44.29,19.87-44.29,44.29c0,24.42,19.87,44.29,44.29,44.29s44.29-19.87,44.29-44.29c0-0.76-0.08-1.51-0.11-2.26 c1.55,0.36,3.15,0.57,4.8,0.57c11.74,0,21.3-9.55,21.3-21.3C229.36,262.53,219.81,252.98,208.07,252.98z M197.67,297.27 c0,21.27-17.31,38.58-38.58,38.58s-38.58-17.31-38.58-38.58c0-21.27,17.31-38.58,38.58-38.58c11.02,0,20.95,4.67,27.99,12.11 c-0.19,1.14-0.31,2.29-0.31,3.48c0,7.84,4.27,14.69,10.6,18.39C197.55,294.17,197.67,295.71,197.67,297.27z M208.07,289.86 c-1.94,0-3.8-0.37-5.51-1.03c-1.42-7.34-4.65-14.04-9.22-19.61c2.11-6.12,7.91-10.53,14.73-10.53c8.59,0,15.59,6.99,15.59,15.59 S216.66,289.86,208.07,289.86z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "307.23,324.81 247.47,252.69 247.47,341.49 253.18,341.49 253.18,268.53 312.94,340.65 312.94,252.65  307.23,252.65  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "411.28,258.69 445.28,258.69 445.28,341.09 450.99,341.09 450.99,258.69 484.98,258.69 484.98,252.98  411.28,252.98  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M367.06,258.69c18.64,0,22.91,10.47,24.73,14.94c0.23,0.56,0.42,1.02,0.59,1.38l5.14-2.48 c-0.13-0.27-0.27-0.62-0.44-1.05c-2.06-5.06-7.53-18.49-30.02-18.49c-23.55,0-31.94,12.18-31.94,23.57 c0,5.01,2.26,21.49,31.37,23.37c15.93,1.03,25.07,7.56,25.07,17.93c0,4.31-1.79,18.39-24.89,18.39 c-20.96,0-25.76-15.23-25.95-15.87l-5.49,1.58c0.06,0.2,6.07,19.99,31.44,19.99c29.12,0,30.6-20.08,30.6-24.1 c0-5.08-2.19-21.81-30.41-23.63c-16.3-1.05-26.03-7.65-26.03-17.67C340.83,272.36,342.72,258.69,367.06,258.69z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M563.93,277.35c0-16.74-15.83-24.37-30.54-24.37h-28.55v88.11h5.71v-82.4h22.84 c11.96,0,24.83,5.84,24.83,18.66c0,14.49-12.31,19.65-23.84,19.65h-14.1l38.61,45.93l4.37-3.67l-30.72-36.54h1.84 C552.06,302.71,563.93,292.52,563.93,277.35z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M647.84,305.44c0,7.11-2.04,30.32-28.32,30.32c-21.23,0-26.89-19.24-26.89-30.61v-52.51h-5.71v52.51 c0,12.56,6.81,36.32,32.6,36.32c25.09,0,34.03-18.61,34.03-36.03v-52.79h-5.71V305.44z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M717.8,335.76c-21.39,0-38.8-17.41-38.8-38.8s17.41-38.8,38.8-38.8c10.36,0,20.11,4.04,27.44,11.36l4.04-4.04 c-8.41-8.41-19.58-13.04-31.47-13.04c-24.54,0-44.51,19.97-44.51,44.51c0,24.54,19.97,44.51,44.51,44.51 c11.91,0,23.1-4.64,31.51-13.07l-4.04-4.03C737.93,331.71,728.18,335.76,717.8,335.76z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "801.76,298.87 835.49,252.65 828.42,252.65 776.53,323.77 776.53,252.65 770.82,252.65 770.82,341.28  798.29,303.63 829.67,341.49 837.08,341.49  "
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.a00cb40ca3997c3a1a39a4eac2113b14.svg";
export { ForwardRef as ReactComponent };